module.exports = __webpack_public_path__ + "img/download.19298f8b.png";